module.exports = __webpack_public_path__ + "media/bootstrap-icons/headphones-f191f74e.svg";